var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'page--container': !_vm.layout }},[_c('div',{class:{'page--section': !_vm.layout }},[_c('el-row',{attrs:{"gutter":30}},_vm._l((_vm.videos),function(video){return _c('el-col',{key:video.id,attrs:{"sm":_vm.sm}},[_c('media-video-excerpt',{attrs:{"video":video}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }